

















import { Component } from "vue-property-decorator";
import AbstractScene from "@/components/AbstractScene.vue";
import BitetheUnitComponent from "@/components/BitetheUnitComponent.vue";
import BitetheEyeComponent from "@/components/BitetheEyeComponent.vue";
import BitetheKachiComponent from "@/components/BitetheKachiComponent.vue";
import BitetheDoguoonComponent from "@/components/BitetheDoguoonComponent.vue";
import BitetheExplosionComponent from "@/components/BitetheExplosionComponent.vue";
import { GasyaResultUnit } from "@/constants";

@Component({
  components: {
    BitetheUnitComponent,
    BitetheEyeComponent,
    BitetheKachiComponent,
    BitetheDoguoonComponent,
    BitetheExplosionComponent,
  },
})
export default class BitethedustScene extends AbstractScene {
  get bitethedustUnit(): GasyaResultUnit | undefined {
    return this.result.find((v) => v.b);
  }
  beforeMount() {
    if (!this.bitethedustUnit)
      // バイツァ対象がない場合はスキップ
      this.done();
  }
}
